import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4f72566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news c-thirdary" }

import home, { State } from '@/store/movies/home';
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[home.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].movieText)

const state = reactive({
    timer: 0,
    current: 0,
})

onMounted(() => {
    //@ts-ignore
    state.timer = setInterval(onTimer, 5000);
})

onBeforeUnmount(() => {
    clearInterval(state.timer);
})

function onTimer() {
    state.current = (state.current + 1) % data.value.notices.length
}

function className(i: number) {
    if (state.current == i) {
        return 'on'
    }
    if (((state.current + 1) % data.value.notices.length) == i) {
        return 'next'
    }
    if (((state.current - 1 + data.value.notices.length) % data.value.notices.length) == i) {
        return 'prev'
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref(lang).notices) + "： ", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).notices, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item line1", className(i)]),
        key: i
      }, _toDisplayString(item.title), 3))
    }), 128))
  ]))
}
}

})